// this is an autogenerated file from DesignSystem/ManualAutomations/Content/Content/ActiveAction/CreateProcedureReceivables/Content/Content/Claim/Content/Charges/Charge/EditInsuranceCode/Content/InsuranceCode/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_ManualAutomations_Content_Content_ActiveAction_CreateProcedureReceivables_Content_Content_Claim_Content_Charges_Charge_EditInsuranceCode_Content_InsuranceCode{
  vaxiom_insurance_codes(
    where: { deleted: { _eq: false } }
    order_by: { code: asc_nulls_last, title: asc_nulls_last }
  ) {
    id
    code
    title
  }
}

`